import useRoute from "hooks/useRoute";

export type BettingRouteParams = {
  hub?: string;
  tour?: string[];
  sport?: string;
  sports?: string[];
  page: number;
  tab: "next" | "outrights";
  sgm?: string;
};

export const useBettingFilters = (
  defaultFilters: Partial<BettingRouteParams> = { tab: "next", page: 1 },
) => {
  const [setFilters, filters] = useRoute<BettingRouteParams>(
    "(/:hub)(/:sport)/betting(/)(?)(page=:page)(&)(tab=:tab)(&)(sports=:sports)(&)(tour=:tour)(&)(sgm=:sgm)",
    defaultFilters,
  );

  return [filters, setFilters] as const;
};
